import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CurrencyFormat from "react-currency-format";
import { useStateContext } from "../../../context/StateContext_US";
import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

const Subtotal = ({ noShipping, taxPrice }) => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(true);
  const [remained, setRemained] = useState(null);
  const {
    basket,
    getBasketTotal,
    getBasketQuantity,
    getSubtotal,
    getShipping,
    freeshippingRate,
    finalPrice,
  } = useStateContext();

  let subtotal = getSubtotal();

  console.log(subtotal);

  useEffect(() => {
    if (subtotal < freeshippingRate && basket.length > 0) {
      setRemained(freeshippingRate - subtotal);
    } else {
      setRemained(null);
    }
  }, [basket, subtotal, freeshippingRate]);

  return (
    <Box sx={{ py: 3 }}>
      {show && remained && !noShipping && (
        <Box sx={{ pb: 3, color: "orange" }}>
          <Alert sx={{ fontSize: "12px" }} onClose={() => setShow(false)}>
            <CurrencyFormat
              renderText={(remained) => (
                <strong>You are {remained} away from free shipping</strong>
              )}
              decimalScale={2}
              value={remained}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </Alert>
        </Box>
      )}
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
          }}
        >
          <Box>
            {t("subtotal")} ({getBasketQuantity()}{" "}
            {getBasketQuantity() > 1 ? t("items") : t("item")}):
          </Box>

          <CurrencyFormat
            renderText={(subtotal) => <strong>{subtotal}</strong>}
            decimalScale={2}
            value={subtotal}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("shipping")}:</Box>

          <Box>
            <strong>
              {+getSubtotal() < freeshippingRate ? (
                <CurrencyFormat
                  // renderText={(5) => <strong>{5}</strong>}
                  decimalScale={2}
                  value={5}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              ) : (
                t("free_shipping")
              )}
            </strong>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            pt: 2,
          }}
        >
          <Box>{t("tax")}:</Box>
          <Box>
            {taxPrice ? (
              <CurrencyFormat
                renderText={(taxPrice) => <strong>{taxPrice}</strong>}
                decimalScale={2}
                value={taxPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            ) : (
              "TBD"
            )}
          </Box>
        </Box>
        <Box
          sx={{
            paddingTop: "10px",
            width: 1,
            borderBottom: "1px solid black",
            pb: 3,
          }}
        ></Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "15px",
            pt: 2,
          }}
        >
          <Box>{t("total")}:</Box>
          <Box>
            {subtotal < freeshippingRate ? (
              <CurrencyFormat
                renderText={(subtotal) => <strong>{subtotal}</strong>}
                decimalScale={2}
                value={subtotal + 5}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            ) : (
              <CurrencyFormat
                renderText={(subtotal) => <strong>{subtotal}</strong>}
                decimalScale={2}
                value={subtotal}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            )}
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default Subtotal;
